export const DataCategories = [
    { 
        name: "Maçã",
        slug: "maca",
        category_id : 1,
        primary_color: "#E46474",
        secondary_color: "#872F3A"
    }, 
    { 
        name: "Manga",
        slug: "manga",
        category_id : 2,
        primary_color: "#75A149",
        secondary_color: "#3C5F19"
    }, 
    { 
        name: "Abacaxi",
        slug: "abacaxi",
        category_id : 3,
        primary_color: "#9FDE6C",
        secondary_color: "#578433"
    }, 
    { 
        name: "Banana",
        slug: "banana",
        category_id : 4,
        primary_color: "#F2DA64",
        secondary_color: "#988420"
    }, 
    { 
        name: "Pêra",
        slug: "pera",
        category_id : 5,
        primary_color: "#DEE880",
        secondary_color: "#88922B"
    }, 
];